import { cached } from '@porotutu/react'
import { listQueryOf } from '@porotutu/react/paging'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { permittedRoute, signedInRoute } from '@/router/root'
import { CRM_EARNING_RULE_SORTABLE, EARNING_RULE_FILTERS, EARNING_TRIGGERS } from '../vocabulary'
import { ACTIVE_CHOICES } from './components/filters'
import { earningRuleQuery, earningRulesQuery } from './queries'

const earningRuleSearch = (raw: Record<string, unknown>) =>
  listQueryOf(raw, CRM_EARNING_RULE_SORTABLE, [], EARNING_RULE_FILTERS, {
    trigger_type: EARNING_TRIGGERS,
    active: ACTIVE_CHOICES,
  })

export const earningRulesRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('earning_rules'),
  path: '/earning-rules',
  validateSearch: earningRuleSearch,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => context.queryClient.query(cached(earningRulesQuery(deps))),
  component: lazyRouteComponent(() => import('./pages'), 'EarningRulesPage'),
})

export const earningRuleRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('earning_rules'),
  path: '/earning-rules/$id',
  validateSearch: earningRuleSearch,
  loader: ({ context, params }) => context.queryClient.query(cached(earningRuleQuery(params.id))),
  component: lazyRouteComponent(() => import('./pages'), 'EarningRulePage'),
})

export const earningRuleRoutes = [earningRulesRoute, earningRuleRoute]
